/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Foot_PlanInputs */

const en_mk_foot_plan = /** @type {(inputs: Mk_Foot_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan`)
};

const id_mk_foot_plan = /** @type {(inputs: Mk_Foot_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rencana`)
};

/**
* | output |
* | --- |
* | "Plan" |
*
* @param {Mk_Foot_PlanInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_foot_plan = /** @type {((inputs?: Mk_Foot_PlanInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Foot_PlanInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_foot_plan(inputs)
	return en_mk_foot_plan(inputs)
});